export default "__VITE_PUBLIC_ASSET__1ac5113e__"